import { combineReducers } from 'redux';
import { allMatchesReducer } from './allMatchesReducer';
// import { LeagueReducer } from './LeagueReducer';

export const rootReducer = combineReducers({allMatchesReducer
})